import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import SingleValueWidget from './single-value-widget';
import TwyValueWidget from './twy-value-widget';

import TcWidget from './tc-widget';
import DashboardFilter from './dashboard-filters';
// import Seg from "./../utils/segment-track-handler-helper"

@inject('appStore')
@observer
export default class DashBoardTcView extends Component {
    constructor(props) {
        super(props);
        this.dashboardFilter = new DashboardFilter();
    }

    trackWithHandle(name, handler, data) {
        return function(args) {
            // appStore.analytics.track(name,data)
            return handler(args);
        };
    }

    render() {
        return (
            <div className="tab-pane active">
                <div className="row">
                    <div className="col-xs-12 col-md-4 fill">
                        <SingleValueWidget
                            label={'Total Pending Transactions'}
                            icon={'fa-home'}
                            filter={this.dashboardFilter.filters.PendingTransactions}
                            handleClick={this.trackWithHandle('Dashboard Filter Selected', this.props.handleClick, {
                                filter: 'Total Pending Transactions',
                            })}
                            value={appStore.dashboardStore.totalPendingTransactions}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 fill">
                        <SingleValueWidget
                            label={'Total Active Listings'}
                            icon={'fa-handshake-o'}
                            filter={this.dashboardFilter.filters.ActiveLisitings}
                            handleClick={this.trackWithHandle('Dashboard Filter Selected', this.props.handleClick, {
                                filter: 'Total Active Listings',
                            })}
                            value={appStore.dashboardStore.totalActiveListings}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 fill">
                        <SingleValueWidget
                            label={'Closed Files This Month'}
                            icon={'fa-key'}
                            filter={this.dashboardFilter.filters.ClosedFileCountsMtd}
                            handleClick={this.trackWithHandle('Dashboard Filter Selected', this.props.handleClick, {
                                filter: 'Closed Files This Month',
                            })}
                            value={appStore.dashboardStore.closedFileCounts.mtd}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 fill">
                        <SingleValueWidget
                            label={'Files Closing This Week'}
                            icon={'fa-key'}
                            filter={this.dashboardFilter.filters.FilesClosingThisWeek}
                            handleClick={this.trackWithHandle('Dashboard Filter Selected', this.props.handleClick, {
                                filter: 'Files Closing This Week',
                            })}
                            value={appStore.dashboardStore.closedFileCounts.closing}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 fill">
                        <SingleValueWidget
                            label={'New Transactions This Week'}
                            icon={'fa-inbox'}
                            filter={this.dashboardFilter.filters.NewTransactionCountsWtd}
                            handleClick={this.trackWithHandle('Dashboard Filter Selected', this.props.handleClick, {
                                filter: 'New Transactions This Week',
                            })}
                            value={appStore.dashboardStore.newTransactionCounts.wtd}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 fill">
                        <SingleValueWidget
                            label={'New Listings This Week'}
                            icon={'fa-paper-plane'}
                            filter={this.dashboardFilter.filters.NewListingCountsWtd}
                            handleClick={this.trackWithHandle('Dashboard Filter Selected', this.props.handleClick, {
                                filter: 'New Listings This Week',
                            })}
                            value={appStore.dashboardStore.newListingCounts.wtd}
                        />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/dashboard/dashboard-tc-view.js